import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import Rating from 'components/Rating';
import { toThousandsSeparator } from 'helpers/NumberFormats';
import styles from 'styles/components/productdetail/reviewSummary.scss';

const ReviewSummary = ({ rating, numReviews, productId, linkedToReviews = true }, { testId }) => {
  if (numReviews > 0) {
    const contents = (
      <span>
        <Rating
          additionalClasses={styles.ratingLayout}
          rating={rating}
          reviewCount={numReviews}
          forceDesktopRating={true}
          fullSize={true}/>
        <span className={styles.ratingLabel}>
          {' '}
          <span>{toThousandsSeparator(numReviews)}</span>
          {' '}
          <span>{`Review${numReviews === '1' ? '' : 's'}`}</span>
        </span>
      </span>
    );

    return (
      <div data-test-id={testId('productReviews')}>
        {linkedToReviews ? <Link to={`/product/review/${productId}`}>{contents}</Link> : contents}
      </div>
    );
  } else {
    return null;
  }
};

ReviewSummary.propTypes = {
  rating: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  numReviews: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  productId: PropTypes.string.isRequired,
  linkedToReviews: PropTypes.bool
};

ReviewSummary.contextTypes = {
  testId: PropTypes.func
};

export default ReviewSummary;
